import React from 'react';

export default function Skeleton({containerClass}){
  return (
    <div className={`${containerClass} skeleton--container`}>
      <div className="skeleton--loader"></div>
    </div>
  )
}